export const color = {
  backgroundColor: '#FFF',
  iconColor     : "white",
  mainIconColor : "black",
  menuLight     : "rgba(255,255,255,0.5)",
  bigSeparator  : "#F5F5F9",
  detailsColor  : "#626262",
  menuUnselected: "#F3F3F3",
  lightGray:     "#BBBBBB",
  inputText:     "#8B8B8B",
  screenLimit : 980,
  appFonts : {
    'main-regular': require('../assets/fonts/main-regular.ttf'),
    'main-bold'   : require('../assets/fonts/main-bold.ttf'),
  }
};